import { collection, doc, endAt, endBefore, getCountFromServer, getDocs, limit, orderBy, query, setDoc, startAfter, startAt, where } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { app, db } from '../Admin/Config/Config';
import ClipPayment from './ClipPayment';
import { useUser } from '../Auth/UsersContext';
import { getFunctions, httpsCallable } from 'firebase/functions';
import Toast from '../Toast/Toast';
import LoadingTwo from '../Loading/LoadingTwo';
import { VolumeX,Volume2 } from 'lucide-react';
import { usePaymentSuccess } from '../Payment/PaymentStatusContext';
export default function Viewclips() {
   const [selectedLetter, setSelectedLetter] = useState(null);
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [paymentOpen, setPaymentOpen] = useState(false);
  const [phraseVideoCount, setPhraseVideoCount] = useState(0);
  const [toastDetails, setToastDetails] = useState(null);
  const [docCount, setDocCount] = useState(0);
  const { user } = useUser();
// ================== Fetch Topics ================== //
  const [topicList, setTopicList] = useState([]);
const fetchTopics = async (q) => {
  const snapshot = await getCountFromServer(q);
  setDocCount(snapshot.data().count);
  const limitedQuery = query(q, limit(300));
  const topicsSnap = await getDocs(limitedQuery);
  const topicsData = topicsSnap.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
  setTopicList(topicsData);
};
    const { openPaymentSuccess } = usePaymentSuccess();

useEffect(() => {
  const topicsRef = collection(db, "jaffers_english_phrases");
   const urlParams = new URLSearchParams(window.location.search);
   const id = urlParams.get("id");
    
 if (id==="all"){
    
      if (!selectedLetter) {
        const q = query(
          topicsRef,
          where("status", "==", true),
          orderBy("order","desc"),
          // orderBy("SearchKey","asc"),
          // limit(200)
        );
        fetchTopics(q);
      } else {
        const q = query(
          topicsRef,
          where("status", "==", true),
          orderBy("SearchKey", "asc"),
          orderBy("order", "desc"),
          startAt(selectedLetter.toUpperCase()),
          endAt(selectedLetter + "\uf8ff"),
          // limit(200)
        );
        fetchTopics(q);
      }
      }else {
           if (!selectedLetter) {
             const q = query(
               topicsRef,
               where("status", "==", true),
               where("level", "==", id.toLowerCase()),
               // orderBy("SearchKey", "asc"),
               orderBy("order", "desc"),
               // limit(200)
             );
             fetchTopics(q);
           } else {
        const q = query(
          topicsRef,
          where("status", "==", true),
          where("level", "==", id.toLowerCase()),
          orderBy("SearchKey", "asc"),
          orderBy("order", "desc"),
          startAt(selectedLetter.toUpperCase()),
          endAt(selectedLetter + "\uf8ff"),
          // limit(200)
        );
        fetchTopics(q);
      }
    }
}, [selectedLetter]);

const handleLetterChange = (newLetter) => {
  setSelectedLetter(newLetter.toUpperCase());
};
 

// ================= A-Z Alphabet ================== //
  const alphabet = Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i));


const handleSaveClip = (clip) => {
  setDoc(doc(db, "users", user.uid, "saved_clips", clip.id), {
    ...clip,
    saved_date: new Date(),
  },{ merge: true });

  setToastDetails({
    type: "success",
    message: "Clip saved successfully",
  });
};
const [video, setVideo] = useState(null);
const [viewedVideoIds, setViewedVideoIds] = useState(new Set()); 
const [lastDoc, setLastDoc] = useState(null); 
const [prevDoc, setPrevDoc] = useState(null); 
const [phrase, setPhrase] = useState("");
const [videoList, setVideoList] = useState([]);
const [watched, setWatched] = useState(0);
const fetchVideo = async (direction = "initial", ph) => {
  try {
    const effectivePhrase = ph ?? phrase;
    let q = query(
      collection(db, "jaffers_english_clipchat_videos"),
      where("phrase", "==", effectivePhrase),
      orderBy("order", "desc"),
      limit(1)
    );

    if (direction === "next" && lastDoc) {
      q = query(
        collection(db, "jaffers_english_clipchat_videos"),
        where("phrase", "==", effectivePhrase),
        orderBy("order", "desc"),
        startAfter(lastDoc),
        limit(1)
      );
    } else if (direction === "prev" && prevDoc) {
      q = query(
        collection(db, "jaffers_english_clipchat_videos"),
        where("phrase", "==", effectivePhrase),
        orderBy("order", "desc"),
        endBefore(prevDoc),
        limit(1)
      );
    }

    const querySnapshot = await getDocs(q);
    if (!querySnapshot.empty) {
      const docSnap = querySnapshot.docs[0];
      const videoData = { ...docSnap.data(), id: docSnap.id };
      setWatched(watched + 1);
      if (!viewedVideoIds.has(videoData.id)) {
        setVideo(videoData);
        setVideoList((prev) => [...prev, videoData]);
        setViewedVideoIds((prev) => new Set(prev).add(videoData.id));
        if (direction === "next" || direction === "initial") {
          setLastDoc(docSnap);
          if (!prevDoc || direction === "initial") {
            setPrevDoc(docSnap); 
          }
        } else if (direction === "prev") {
          setPrevDoc(docSnap);
          setLastDoc(docSnap); 
        }
        setIsVideoModalOpen(true);
      } else if (direction !== "initial") {
        fetchVideo(direction, effectivePhrase);
      }
    } else {
      console.log(
        `No more videos found in ${direction} direction for phrase: ${effectivePhrase}`
      );
      setVideo(null);
      handleModalClose();
    }
  } catch (error) {
    console.error("Error fetching video:", error);
    setVideo(null);
    handleModalClose();
  }
};
const handleModalClose = () => {
  setIsVideoModalOpen(false);
  setVideo(null);
  setViewedVideoIds(new Set());
  setLastDoc(null);
  setPrevDoc(null);
};
const handleClipNavigation = (direction) => {
  if (!video) return;

  if (direction === "prev") {
    if (watched <= 0) {
      alert("No more clips");
      handleModalClose();
    } else {
      setVideo(videoList[watched - 1]);
      setWatched(watched - 1);
    }
  } else {
    if (videoList && watched < videoList.length - 1) {
      setVideo(videoList[watched + 1]);
      setWatched(watched + 1);
    } else {
      fetchVideo(direction);
    }
  }
};
const [purchaseLoading, setPurchaseLoading] = useState(false);
const handlePaymentResult = (result) => {
  setPurchaseLoading(true);
    const functions = getFunctions(app, "asia-south1");
    const payload = {
      platform: "web",
      plan_id: result,
      purchase_type: "clip_chat",
    };
    const paymentRequest = httpsCallable(functions, "orderIdTalk");
    paymentRequest({
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTVf5kvPJI5bjBGVG5PiiueDXduVAV5p2kMcA&s",
      ...payload,
    }).then((result) => {
      const order = result.data;
      if (order && order !== 404) {
        const options = {
          key: process.env.REACT_APP_RAZOR_KEY,
          amount: order.amount,
          currency: order.currency,
          name: "Jaffer's English",
          description: "Talk Plan",
          image:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTVf5kvPJI5bjBGVG5PiiueDXduVAV5p2kMcA&s",
          order_id: order.id,
          method: {
            netbanking: true,
            card: true,
            upi: false,
            wallet: true,
          },
          handler: function (response) {
            openPaymentSuccess({
              status: "success",
              orderId: order.id,
              paymentId: response.razorpay_payment_id,
              courseTitle: "Talk Plan",
              amount: order.amount / 100,
            });           },
          prefill: {
            name: user.name,
            email: user.email,
            contact: user.mobile,
          },
          notes: {
            address: "Razorpay Corporate Office",
          },
          theme: {
            color: "#3399cc",
          },
          modal: {
            ondismiss: function () {
              // setloading(false);
            },
          },
        };

        try {
          const rzp1 = new window.Razorpay(options);
          rzp1.open();
          setPurchaseLoading(false);
          rzp1.on("payment.failed", function (response) {
            openPaymentSuccess({
              status: "failed",
              orderId: order.id||"",
              paymentId: response.razorpay_payment_id||"",
              courseTitle: "Talk Plan",
              amount: order.amount / 100,
              message: response.error.code,
            });          });
        } catch (error) {
          setPurchaseLoading(false);
          console.error("Razorpay Error:", error);
          openPaymentSuccess({
            status: "failed",
            orderId: order.id||"",
            courseTitle: "Talk Plan",
            amount: order.amount / 100,
          });        }
      }
    });
};

useEffect(() => {
  if(!isVideoModalOpen){
    handleModalClose()
  }
}, [isVideoModalOpen]);
const [showCaption,setshowCaption] = useState(false) 
const [isMuted, setIsMuted] = useState(false);
  return (
    <div className="min-h-screen bg-black p-6 flex gap-8">
      <LoadingTwo toggle={purchaseLoading} />
      {paymentOpen && (
        <ClipPayment
          toogle={paymentOpen}
          onResult={handlePaymentResult}
          onClose={() => setPaymentOpen(false)}
        />
      )}
      <Toast
        type={toastDetails?.type}
        message={toastDetails?.message}
        onComplete={() => setToastDetails(null)}
      />
      <div className="flex-1 space-y-5">
      
        {topicList &&
          topicList.map((topic, index) => {
            const color =
              topic.level === "beginner"
                ? "yellow"
                : topic.level === "intermediate"
                ? "blue"
                : "green";
            return (
            <div
              key={topic.id}
              className="group relative p-6 pr-8 rounded-2xl backdrop-blur-lg 
                      bg-gradient-to-r from-emerald-900/60 to-emerald-800/20
                      shadow-2xl shadow-emerald-900/30"
            >
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-emerald-500/10 to-emerald-600/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10" />
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="px-4 py-2  rounded-full bg-emerald-500/10 border border-emerald-400/20 text-emerald-100 text-md font-medium">
                      {docCount - index}
                    </span>
                    <h3 className="text-xs sm:text-xl ml-2 font-bold text-emerald-200">
                      {topic.phrase}
                    </h3>
                  </div>
                </div>
                <button
                  onClick={() => {
                    if (user?.clip_chat_payment) {
                      setPhrase(topic.phrase);
                      setPhraseVideoCount(topic.video_count);
                      fetchVideo("initial", topic.phrase);
                    } else {
                      setPaymentOpen(true);
                    }
                  }}
                  className={`ml-4 px-4 py-2.5 flex items-center gap-2 rounded-lg transition-all duration-200 text-sm font-medium ${
                    color === "yellow"
                      ? "bg-yellow-900/50 hover:bg-yellow-400/10 border border-yellow-800 hover:border-yellow-400/30 text-yellow-300 hover:text-yellow-200"
                      : color === "blue"
                      ? "bg-blue-900/50 hover:bg-blue-400/10 border border-blue-800 hover:border-blue-400/30 text-blue-300 hover:text-blue-200"
                      : "bg-green-500/50 hover:bg-green-400/10 border border-green-600 hover:border-green-600/30 text-green-200 hover:text-green-200"
                  }`}
                >
                  View Clip
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4 transform group-hover:translate-x-1 transition-transform"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17 8l4 4m0 0l-4 4m4-4H3"
                    />
                  </svg>
                </button>
              </div>
            </div>
          )})
        }
      </div>

      {isVideoModalOpen && (
        <div
          className="fixed inset-0 bg-black/80 backdrop-blur-2xl flex items-center justify-center z-50 p-4"
          onClick={() => setIsVideoModalOpen(false)}
        >
          <div
            className="relative w-full h-full max-w-3xl max-h-[90vh] md:max-h-[80vh] rounded-xl md:rounded-2xl overflow-hidden border border-emerald-400/30 shadow-2xl shadow-emerald-900/50"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header Section */}
            <div
              onClick={() => setshowCaption(!showCaption)}
              className="absolute top-0 left-0 right-0 z-40 flex justify-between items-start p-3 md:p-5 bg-gradient-to-b from-emerald-900/30 to-transparent cursor-pointer"
            >
              <div>
                <button className="flex items-center gap-1.5 md:gap-2.5 bg-gradient-to-br from-emerald-400 to-emerald-600 hover:from-emerald-300 hover:to-emerald-500 text-white px-3 py-1.5 md:px-4 md:py-2.5 rounded-lg md:rounded-xl text-xs md:text-sm font-medium transition-all duration-300 active:scale-[0.97] shadow-lg shadow-emerald-500/20 hover:shadow-emerald-500/30 group border border-white/10 backdrop-blur-sm">
                  {video?.phrase ?? ""}

                  {/* Modern divider */}
                  <span className="h-4 md:h-5 w-[1px] bg-gradient-to-t from-transparent via-white/50 to-transparent"></span>

                  <span className="flex items-center gap-1">
                    <span className="relative text-xs md:text-sm">
                      Show Meaning
                      {/* Animated underline on hover */}
                      <span className="absolute left-0 -bottom-0.5 h-[1.5px] w-0 group-hover:w-full bg-white transition-all duration-300"></span>
                    </span>

                    {/* Modern "sparkle" icon */}
                    <svg
                      className="ml-1 w-3 h-3 md:w-4 md:h-4"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293z"
                      />
                    </svg>
                  </span>
                </button>
              </div>

              {/* Close Button */}
              <button
                className="p-1.5 md:p-2.5 text-emerald-200 hover:text-white hover:bg-emerald-400/20 bg-emerald-900/20 rounded-full border border-emerald-400/30 transition-all duration-300 hover:scale-110"
                onClick={() => setIsVideoModalOpen(false)}
              >
                <svg
                  className="w-5 h-5 md:w-7 md:h-7"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* Video Player Container */}
            <div className="relative w-full h-full bg-emerald-900/10 aspect-video">
              <ReactPlayer
                key={video?.id ?? ""}
                url={
                  video?.video_type === "youtube"
                    ? "https://www.youtube.com/watch?v=" + video?.video_url
                    : video?.video_url ?? ""
                }
                muted={isMuted}
                width="100%"
                loop={true}
                controls={false}
                playing
                height="100%"
                className="react-player rounded-lg md:rounded-xl"
                config={{
                  youtube: {
                    playerVars: {
                      controls: 0,
                      fs: 0,
                      modestbranding: 1,
                      rel: 0,
                    },
                  },
                  file: {
                    attributes: {
                      controlsList: "nofullscreen",
                    },
                  },
                }}
                playIcon={
                  <div className="w-12 h-12 md:w-16 md:h-16 bg-emerald-400/80 rounded-full flex items-center justify-center backdrop-blur-sm">
                    <svg
                      className="w-6 h-6 md:w-8 md:h-8 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
                      />
                    </svg>
                  </div>
                }
              />
            </div>

            {/* Caption */}
            {showCaption && (
              <div className="absolute top-14 md:top-16 left-2 md:left-4 z-20 max-w-xs md:max-w-lg">
                <div className="flex items-start gap-3">
                  <div className="relative bg-white p-4 md:p-8 rounded-tr-xl md:rounded-tr-2xl rounded-tl-xl md:rounded-tl-2xl rounded-br-xl md:rounded-br-2xl max-w-xs md:max-w-xl">
                    <div className="absolute -left-[6px] md:-left-[7px] top-0 w-[6px] md:w-[7px] h-[6px] md:h-[7px] overflow-hidden">
                      <div className="absolute -right-[8px] md:-right-[10px] top-0 w-[8px] md:w-[10px] h-[8px] md:h-[10px] bg-white/90 backdrop-blur-sm transform rotate-45 origin-bottom-left"></div>
                    </div>
                    <p className="text-violet-700 text-sm md:text-xl">
                      {video?.meaning ?? ""}
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* Navigation Arrows */}
            <div className="absolute inset-0 flex justify-between items-center px-2 md:px-6">
              <button
                onClick={() => handleClipNavigation("prev", phrase)}
                className="text-emerald-200 hover:text-white p-2 md:p-3.5 hover:bg-emerald-400/20 bg-emerald-900/20 rounded-full border border-emerald-400/30 transition-all duration-300 hover:scale-110 hover:shadow-lg hover:shadow-emerald-400/10"
              >
                <svg
                  className="w-6 h-6 md:w-8 md:h-8"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15 19l-7-7 7-7"
                  />
                </svg>
              </button>
              <button
                onClick={() => handleClipNavigation("next", phrase)}
                className="text-emerald-200 hover:text-white p-2 md:p-3.5 hover:bg-emerald-400/20 bg-emerald-900/20 rounded-full border border-emerald-400/30 transition-all duration-300 hover:scale-110 hover:shadow-lg hover:shadow-emerald-400/10"
              >
                <svg
                  className="w-6 h-6 md:w-8 md:h-8"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </button>
            </div>

            {/* Bottom Controls */}
            <div className="absolute bottom-0 left-0 right-0 z-40 flex justify-between items-center p-3 md:p-5 bg-gradient-to-t from-emerald-900/30 to-transparent">
              {/* Clip Counter */}
              <div className="text-emerald-200 text-xs md:text-sm font-medium bg-emerald-900/20 px-2 py-1 md:px-4 md:py-2 rounded-full border border-emerald-400/40 backdrop-blur-sm">
                Clip{" "}
                <span className="text-emerald-400">
                  {videoList?.length ?? 0}
                </span>{" "}
                of {phraseVideoCount ?? 0}
              </div>

              {/* Right side buttons */}
              <div className="flex items-center gap-1 md:gap-2">
                {/* Mute Button */}
                <button
                  onClick={() => setIsMuted(!isMuted)}
                  className="p-1.5 md:p-2 bg-white/80 hover:bg-white backdrop-blur-sm rounded-full transition-all duration-300 hover:scale-105"
                  aria-label={isMuted ? "Unmute" : "Mute"}
                >
                  {isMuted ? (
                    <VolumeX className="w-4 h-4 md:w-5 md:h-5 text-black" />
                  ) : (
                    <Volume2 className="w-4 h-4 md:w-5 md:h-5 text-black" />
                  )}
                </button>

                {/* Save Clip Button */}
                <button
                  onClick={() => handleSaveClip(video)}
                  className="flex items-center space-x-1 md:space-x-2 text-emerald-100 hover:text-white px-2 py-1 md:px-4 md:py-2 bg-emerald-400/40 hover:bg-emerald-400/70 rounded-full border border-emerald-400/30 transition-all duration-300 hover:scale-105 text-xs md:text-sm"
                >
                  <svg
                    className="w-3 h-3 md:w-5 md:h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"
                    />
                  </svg>
                  <span className="font-medium">Save</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* onClick={() => setIsModalOpen(true)}  */}

      <div className="sticky top-4 h-fit hidden md:block">
        <div className="flex flex-col gap-2 p-2 bg-emerald-900/30 rounded-xl backdrop-blur-lg">
          {alphabet.map((letter) => {
            const hasTopics = selectedLetter === letter;
            const isActive = selectedLetter === letter;

            return (
              <button
                key={letter}
                onClick={() => {
                  if (selectedLetter === letter) {
                    setSelectedLetter(null);
                  } else {
                    handleLetterChange(letter);
                  }
                }}
                className={`w-8 h-8 flex items-center justify-center rounded-lg transition-all
                  ${
                    isActive
                      ? "bg-emerald-500 text-black font-bold"
                      : hasTopics
                      ? "text-emerald-400 hover:bg-emerald-900/50"
                      : "text-emerald-800 cursor-default"
                  }`}
              >
                {letter}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}